import { tokens } from '@fluentui/react-components';

import { DAILY_HABITS_CONFIG, ERROR_MESSAGES } from 'src/utils/constants';
import CircularIcon from '../../atoms/circular-icon/CircularIcon';
import { useDailyHabitsIconStyles } from './DailyHabitsIcon.styles';

interface DailyHabitsIconProps {
  planId: string
}

const DailyHabitsIcon: React.FC<DailyHabitsIconProps> = ({
  planId,
}) => {
  const styles = useDailyHabitsIconStyles();

  if (!(planId in DAILY_HABITS_CONFIG)) {
    throw new Error(ERROR_MESSAGES.invalidDailyHabitsType(planId));
  }

  const { icon: Icon, color } = DAILY_HABITS_CONFIG[planId as keyof typeof DAILY_HABITS_CONFIG];
  const componentIcon = <span className={styles.icon}><Icon color={tokens.colorStrokeFocus1} /></span>;

  return (
    <CircularIcon
      icon={componentIcon}
      backgroundColor={color}
      className={styles.container}
    />
  );
};

export default DailyHabitsIcon;
